document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const button = document.querySelector(".customer-inquiry-form .btn-submit");
    const colorElement = document.querySelector(".inquiryBtncolor");

    if (button && colorElement) {
      const inquiryBgColor = colorElement.getAttribute("inquiry-btn-bg-color");
      const inquiryTextColor = colorElement.getAttribute(
        "inquiry-btn-text-color"
      );
      const inquiryHoverColor = colorElement.getAttribute("inquiry-btn-hover-color");
      const inquiryHoverTextColor = colorElement.getAttribute(
        "inquiry-btn-hover-text-color"
      );

      button.style.backgroundColor = inquiryBgColor;
      button.style.color = inquiryTextColor;

      button.addEventListener("mouseenter", function () {
        button.style.backgroundColor = inquiryHoverColor;
        button.style.color = inquiryHoverTextColor;
      });

      button.addEventListener("mouseleave", function () {
        button.style.backgroundColor = inquiryBgColor;
        button.style.color = inquiryTextColor;
      });

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
